import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { change_Lang } from "../../actions/Helper_action";
import { Button } from "antd";
import { Create_Type_Exp } from "../../actions/Account_action";
const CreateExp = ({ onCloseModel }) => {
  const dispatch = useDispatch();
  const [name_ku, setname_ku] = useState("");
  const [name_en, setname_en] = useState("");
  const [name_ar, setname_ar] = useState("");
  const onCreateExp = () => {
    const user = {
      name_ku,
      name_ar: name_ar !== "" ? name_ar : name_ku,
      name_en: name_en !== "" ? name_en : name_ku,
    };
    if (name_ku === "") {
      Swal.fire({
        title: "OPS",
        text: dispatch(change_Lang("Please Check Inputs")),
        icon: "error",
        html: `<b class="fk">${dispatch(
          change_Lang("Please Check Inputs")
        )}</b>`,
        confirmButtonText: dispatch(change_Lang("Ok")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      dispatch(Create_Type_Exp(user));
      onCloseModel();
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${dispatch(
          change_Lang("You successfully tainted your work")
        )}</b>`,
        icon: "success",
        confirmButtonText: dispatch(change_Lang("success")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      setname_ku("");
      setname_ar("");
      setname_en("");
    }
  };
  return (
    <>
      <Fragment>
        <form className="needs-validation user-add">
          <h4 className="d-flex justify-content-center">
            {dispatch(change_Lang("Create Cost"))}
          </h4>
          <div className="form-group row">
            <label className="col-xl-3 col-md-4">
              <span>*</span>
              {dispatch(change_Lang("expenses (Kurdish)"))}
            </label>
            <input
              className="form-control col-xl-8 col-md-7"
              name="name_ku"
              value={name_ku}
              type="text"
              onChange={(e) => setname_ku(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-md-4">
              <span>*</span>
              {dispatch(change_Lang("expenses (Arabic)"))} :
            </label>
            <input
              className="form-control col-xl-8 col-md-7"
              name="name_ar"
              value={name_ar === 0 ? "" : name_ar}
              type="text"
              onChange={(e) => setname_ar(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-md-4">
              <span>*</span>
              {dispatch(change_Lang("expenses (English)"))}:
            </label>
            <input
              className="form-control col-xl-8 col-md-7"
              name="name_en"
              value={name_en === 0 ? "" : name_en}
              type="text"
              onChange={(e) => setname_en(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <Button
            className="ml-4 fk"
            type="primary"
            shape="round"
            style={{
              background: "#d7e4eb",
              color: "#4b85a4",
              border: "none",
            }}
            htmlType="submit"
            onClick={() => {
              onCreateExp();
            }}
          >
            {dispatch(change_Lang("save"))}
          </Button>
        </form>
      </Fragment>
    </>
  );
};

export default CreateExp;
